<div class="gs-page">
  <div class="gs-card">
    <!-- Header -->
    <div class="gs-header">
      <a href="#"
        ><img src="assets/logos/SVG/Handle_Horz_Logo_Black.svg" alt="Handle" class="app-logo-img"
      /></a>
      <p class="gs-sub">Interested in Handle for your school? We'll get back to you shortly.</p>
    </div>

    <!-- Success state -->
    @if (submitted) {
      <div class="gs-success" role="status" aria-live="polite" aria-atomic="true">
        <mat-icon class="gs-success-icon" aria-hidden="true">check_circle</mat-icon>
        <h2 class="gs-success-title">You're on our radar.</h2>
        <p class="gs-success-msg">
          Thanks, {{ form.value.firstName }}! We'll be in touch at
          <strong>{{ form.value.email }}</strong
          >.
        </p>
        <button
          mat-stroked-button
          routerLink="/home"
          class="gs-back-btn"
          aria-label="Return to home page"
        >
          Back to home
        </button>
      </div>
    }

    <!-- Form -->
    @if (!submitted) {
      <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <!-- Role toggle -->
        <p class="gs-field-label">I am a...</p>
        <mat-button-toggle-group
          formControlName="role"
          class="gs-role-group"
          aria-label="Select your role"
        >
          <mat-button-toggle value="School counselor">School counselor</mat-button-toggle>
          <mat-button-toggle value="Administrator">Administrator</mat-button-toggle>
          <mat-button-toggle value="Student / Parent">Student / Parent</mat-button-toggle>
          <mat-button-toggle value="Other">Other</mat-button-toggle>
        </mat-button-toggle-group>

        <!-- Name row -->
        <div class="gs-row">
          <mat-form-field appearance="fill" class="gs-field">
            <mat-label>First name</mat-label>
            <input
              matInput
              formControlName="firstName"
              placeholder="Jordan"
              aria-label="First name"
              aria-required="true"
            />
            @if (form.get('firstName')?.hasError('required')) {
              <mat-error role="alert">Required</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="fill" class="gs-field">
            <mat-label>Last name</mat-label>
            <input
              matInput
              formControlName="lastName"
              placeholder="Lee"
              aria-label="Last name"
              aria-required="true"
            />
            @if (form.get('lastName')?.hasError('required')) {
              <mat-error role="alert">Required</mat-error>
            }
          </mat-form-field>
        </div>

        <!-- Email -->
        <mat-form-field appearance="fill" class="gs-field gs-field-full">
          <mat-label>Email</mat-label>
          <input
            matInput
            type="email"
            formControlName="email"
            placeholder="you@school.edu"
            aria-label="Email address"
            aria-required="true"
          />
          @if (form.get('email')?.hasError('required')) {
            <mat-error role="alert">Required</mat-error>
          }
          @if (form.get('email')?.hasError('email')) {
            <mat-error role="alert">Enter a valid email</mat-error>
          }
        </mat-form-field>

        <!-- School -->
        <mat-form-field appearance="fill" class="gs-field gs-field-full">
          <mat-label>School or district name</mat-label>
          <input
            matInput
            formControlName="school"
            placeholder="Lincoln High School"
            aria-label="School or district name"
          />
        </mat-form-field>

        <!-- Message -->
        <mat-form-field appearance="fill" class="gs-field gs-field-full">
          <mat-label>How can we help?</mat-label>
          <textarea
            matInput
            formControlName="message"
            rows="4"
            placeholder="Tell us a bit about what you're looking for..."
            aria-label="How can we help"
            aria-required="true"
          ></textarea>
          @if (form.get('message')?.hasError('required')) {
            <mat-error role="alert">Required</mat-error>
          }
        </mat-form-field>

        <!-- Error banner -->
        @if (errorMsg) {
          <div class="gs-error-banner" role="alert" aria-live="assertive" aria-atomic="true">
            <mat-icon aria-hidden="true">error_outline</mat-icon>
            {{ errorMsg }}
          </div>
        }

        <!-- Submit -->
        <button
          mat-flat-button
          type="submit"
          class="gs-submit-btn"
          [disabled]="loading"
          [attr.aria-label]="loading ? 'Submitting request' : 'Get in touch'"
        >
          @if (loading) {
            <mat-spinner
              diameter="18"
              class="gs-spinner"
              aria-label="Submitting request"
            ></mat-spinner>
          }
          @if (!loading) {
            <span>Get in touch →</span>
          }
        </button>

        <p class="gs-privacy-note" role="status">
          <mat-icon class="gs-lock-icon" aria-hidden="true">lock</mat-icon>
          Your info goes directly to the Handle team. No spam, ever.
        </p>
      </form>
    }
  </div>
</div>
